import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Menu,
  MenuItem,
  Box,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Chip,
  CircularProgress,
  IconButton
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import SyncIcon from '@material-ui/icons/Sync';
import { useDispatch } from 'react-redux';
import { closeDialogConfirm } from 'src/features/uiSlice';
import { updateOrderStatus, updateOrder, updateOrderInList } from 'src/features/orderSlice';
import { updateTransactionInList } from 'src/features/orderReceiptSlice';
import DialogConfirm from 'src/app/components/DialogConfirm';
import { MESSAGE } from 'src/app/constant/message';
import { isAgencyCustomerOrder, ORDER_STATUS_CONFIG, ORDER_STATUS_OPTIONS } from './orderUtils';

const ConfirmDialogs = ({
  anchorEl,
  handleMenuClose,
  menuOrder,
  isAdmin,
  isSale,
  isAccountant,
  isLeadMarketing,
  isAgency,
  isAdminSale,
  isAgencySale,
  dataLogin,
  handleEditOrder,
  handleCopyOrder,
  handleDeleteOrder,
  handleCancelOrder,
  confirmDelete,
  openCompleteConfirm,
  setOpenCompleteConfirm,
  confirmComplete,
  openCancelConfirm,
  setOpenCancelConfirm,
  confirmCancel,
  handleViewDetailOrder,
  handleBypassSerial,
  onOpenAddReceipt,
  openDeleteReceiptConfirm,
  setOpenDeleteReceiptConfirm,
  confirmDeleteReceipt,
  receiptToDelete,
  agencyDebtMap = {},
  onStatusUpdated
}) => {
  const dispatch = useDispatch();

  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [orderForStatus, setOrderForStatus] = useState(null);
  const [newStatusValue, setNewStatusValue] = useState(0);
  const [submittingStatus, setSubmittingStatus] = useState(false);

  const handleOpenEditStatus = order => {
    setOrderForStatus(order);
    setNewStatusValue(order.status !== undefined ? Number(order.status) : 0);
    setOpenStatusModal(true);
  };

  const handleCloseStatusModal = () => {
    if (submittingStatus) return;
    setOpenStatusModal(false);
    setOrderForStatus(null);
  };

  const handleSaveOrderStatus = async () => {
    if (!orderForStatus) return;
    setSubmittingStatus(true);
    const targetStatus = Number(newStatusValue);
    const targetNote = `Admin cập nhật trạng thái đơn sang: ${ORDER_STATUS_CONFIG[targetStatus]?.label || targetStatus}`;

    try {
      const mainRes = await dispatch(
        updateOrderStatus({
          id: orderForStatus.id,
          data: {
            status: targetStatus,
            note: targetNote
          },
          suffix: '/status'
        })
      );

      if (mainRes && mainRes.meta && mainRes.meta.requestStatus === 'rejected') {
        setSubmittingStatus(false);
        return;
      }

      dispatch(
        updateOrderInList({
          id: orderForStatus.id,
          data: {
            status: targetStatus
          }
        })
      );

      dispatch(
        updateTransactionInList({
          id: orderForStatus.id,
          code: orderForStatus.code || orderForStatus.order_code,
          data: {
            status: targetStatus
          }
        })
      );

      if (onStatusUpdated) {
        onStatusUpdated(orderForStatus, targetStatus);
      }

      handleCloseStatusModal();
    } catch (err) {
      console.error('Error updating order status:', err);
    } finally {
      setSubmittingStatus(false);
    }
  };

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {menuOrder && handleViewDetailOrder && (
          <MenuItem
            onClick={() => {
              handleViewDetailOrder(menuOrder);
              handleMenuClose();
            }}
            style={{ color: '#3f51b5' }}
          >
            <VisibilityIcon fontSize="small" style={{ marginRight: 8 }} />
            Xem chi tiết phiếu
          </MenuItem>
        )}

        {menuOrder && !isAgency && !isSale && !isLeadMarketing && !isAdminSale && !isAgencySale && menuOrder.status !== -1 && onOpenAddReceipt && (
          <MenuItem
            onClick={() => {
              const isAgencyCustomer = isAgencyCustomerOrder(menuOrder);
              const pId = isAgencyCustomer
                ? menuOrder.agency_id || menuOrder.agency?.id
                : menuOrder.end_user_id || menuOrder.end_user?.id || menuOrder.customer_id;
              const pName =
                menuOrder.end_user?.full_name ||
                (!isAgencyCustomer ? (menuOrder.customer_name || menuOrder.customerName) : '') ||
                menuOrder.agency?.name ||
                menuOrder.customer_name ||
                menuOrder.customerName ||
                '';
              const pPhone =
                menuOrder.customer_phone ||
                menuOrder.phone ||
                menuOrder.phone_number ||
                menuOrder.customerPhone ||
                menuOrder.end_user?.phone ||
                menuOrder.end_user?.phone_number ||
                (isAgencyCustomer ? menuOrder.agency?.leader?.phone || menuOrder.agency?.phone : '') ||
                '';
              const pAddr =
                menuOrder.address ||
                menuOrder.customer_address ||
                menuOrder.shipping_address ||
                menuOrder.end_user?.address ||
                (isAgencyCustomer ? menuOrder.agency?.leader?.address || menuOrder.agency?.address || menuOrder.agency_name : '') ||
                '';
              const orderCode = menuOrder.code || menuOrder.order_code || menuOrder.orderCode || '';

              if (isAgencyCustomer) {
                const agKey = String(pId || '');
                const agNameKey = (pName || '').trim().toLowerCase();
                const agInfo = agencyDebtMap ? (agencyDebtMap[agKey] || agencyDebtMap[agNameKey] || null) : null;
                const debt = agInfo?.debt !== undefined ? agInfo.debt : 0;
                onOpenAddReceipt({
                  payer_type: 'AGENCY',
                  payer_id: pId,
                  payer_name: pName,
                  customer_name: pName,
                  customer_phone: pPhone,
                  phone: pPhone,
                  address: pAddr,
                  company: pAddr,
                  amount: debt > 0 ? debt : 0,
                  agency_debt: debt,
                  note: `Thu tiền công nợ Đại lý ${pName}`
                });
              } else {
                onOpenAddReceipt({
                  order_id: menuOrder.id,
                  order_code: orderCode,
                  payer_type: 'END_USER',
                  payer_id: pId,
                  payer_name: pName,
                  customer_name: pName,
                  customer_phone: pPhone,
                  phone: pPhone,
                  address: pAddr,
                  company: pAddr,
                  amount: menuOrder.total_amount || menuOrder.totalAmount || 0,
                  note: orderCode ? `Thu tiền đơn hàng #${orderCode}` : ''
                });
              }
              handleMenuClose();
            }}
            style={{ color: '#2e7d32' }}
          >
            <AddCircleIcon fontSize="small" style={{ marginRight: 8 }} />
            Tạo phiếu thu
          </MenuItem>
        )}

        {menuOrder && (() => {
          const isOwnOrder = Boolean(dataLogin?.id && (
            menuOrder.sale_id === dataLogin.id ||
            menuOrder.created_by === dataLogin.id ||
            menuOrder.sale?.id === dataLogin.id
          ));
          const isSubordinateOrder = Boolean(isLeadMarketing && dataLogin?.id && (
            menuOrder.sale?.manager_id === dataLogin.id ||
            menuOrder.manager_id === dataLogin.id
          ));
          const canModify = isAdmin || isOwnOrder || isSubordinateOrder;

          return (
            <>
              {canModify && (
                <MenuItem
                  onClick={() => {
                    handleEditOrder(menuOrder);
                    handleMenuClose();
                  }}
                  disabled={menuOrder.status >= 4}
                  style={{ color: '#2980b9' }}
                >
                  <EditIcon fontSize="small" style={{ marginRight: 8 }} />
                  Sửa phiếu
                </MenuItem>
              )}
              {isAdmin && (
                <MenuItem
                  onClick={() => {
                    handleOpenEditStatus(menuOrder);
                    handleMenuClose();
                  }}
                  style={{ color: '#e67e22' }}
                >
                  <SyncIcon fontSize="small" style={{ marginRight: 8 }} />
                  Sửa trạng thái đơn
                </MenuItem>
              )}
              {(isAdmin || isSale || isLeadMarketing) && (
                <MenuItem
                  onClick={() => {
                    handleCopyOrder(menuOrder);
                    handleMenuClose();
                  }}
                  style={{ color: '#009688' }}
                >
                  <FileCopyIcon fontSize="small" style={{ marginRight: 8 }} />
                  Sao chép phiếu
                </MenuItem>
              )}
              {menuOrder.status < 3 && isAdmin && (
                <MenuItem onClick={handleDeleteOrder} style={{ color: '#d32f2f' }}>
                  <DeleteIcon fontSize="small" style={{ marginRight: 8 }} />
                  Xóa phiếu
                </MenuItem>
              )}
              {menuOrder.status !== -1 && menuOrder.status < 4 && (isAdmin || isAccountant || canModify) && (
                <MenuItem onClick={handleCancelOrder} style={{ color: '#666' }}>
                  <CloseIcon fontSize="small" style={{ marginRight: 8 }} />
                  Hủy phiếu
                </MenuItem>
              )}
            </>
          );
        })()}
      </Menu>

      <DialogConfirm
        title={MESSAGE.CONFIRM_DELETE_ORDER}
        textOk={MESSAGE.BTN_YES}
        textCancel={MESSAGE.BTN_CANCEL}
        content={MESSAGE.CONTENT_DELETE_ORDER}
        callbackOk={confirmDelete}
        callbackCancel={() => dispatch(closeDialogConfirm())}
      />


      <Dialog
        open={openCancelConfirm}
        onClose={() => setOpenCancelConfirm(false)}
      >
        <DialogTitle>
          <Typography
            variant="h5"
            style={{ fontWeight: 700, color: '#1a1f36' }}
          >
            Xác nhận hủy đơn
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Typography>
            Bạn có chắc chắn muốn hủy đơn hàng này không?
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ marginTop: 8 }}
          >
            Sau khi hủy, các thao tác cho đơn hàng này sẽ bị khóa.
          </Typography>
        </DialogContent>
        <DialogActions style={{ padding: 16 }}>
          <Button
            onClick={() => setOpenCancelConfirm(false)}
            variant="outlined"
            color="primary"
            style={{ fontWeight: 600 }}
          >
            Đóng
          </Button>
          <Button
            onClick={confirmCancel}
            variant="contained"
            color="secondary"
            style={{ fontWeight: 600 }}
          >
            Xác nhận hủy
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(openDeleteReceiptConfirm)}
        onClose={() => setOpenDeleteReceiptConfirm && setOpenDeleteReceiptConfirm(false)}
      >
        <DialogTitle disableTypography style={{ padding: '16px 24px', borderBottom: '1px solid #e0e3ef' }}>
          <Typography variant="h6" style={{ fontWeight: 700, color: '#1a1f36' }}>
            Xác nhận xóa phiếu thu
          </Typography>
        </DialogTitle>
        <DialogContent dividers style={{ padding: '20px 24px' }}>
          <Typography style={{ fontSize: 14, color: '#333' }}>
            Bạn có chắc chắn muốn xóa phiếu thu <strong>#{receiptToDelete?.code || receiptToDelete?.id}</strong> không?
          </Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
            Hành động này sẽ cập nhật lại số tiền đã thanh toán của đơn hàng tương ứng.
          </Typography>
        </DialogContent>
        <DialogActions style={{ padding: '12px 24px', borderTop: '1px solid #e0e3ef' }}>
          <Button
            onClick={() => setOpenDeleteReceiptConfirm && setOpenDeleteReceiptConfirm(false)}
            variant="outlined"
            style={{ fontWeight: 600, textTransform: 'none' }}
          >
            Hủy
          </Button>
          <Button
            onClick={confirmDeleteReceipt}
            variant="contained"
            style={{ backgroundColor: '#d32f2f', color: '#fff', fontWeight: 600, textTransform: 'none' }}
          >
            Đồng ý xóa
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Dialog Sửa trạng thái đơn hàng (Dành riêng cho Admin) ── */}
      <Dialog
        open={openStatusModal}
        onClose={handleCloseStatusModal}
        maxWidth="xs"
        fullWidth
        PaperProps={{ style: { borderRadius: 12 } }}
      >
        <DialogTitle
          disableTypography
          style={{
            borderBottom: '1px solid #e0e3ef',
            padding: '16px 20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography variant="h6" style={{ fontWeight: 700, color: '#1a1f36', fontSize: 18 }}>
            Sửa trạng thái đơn hàng
          </Typography>
          <IconButton size="small" onClick={handleCloseStatusModal} disabled={submittingStatus}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ padding: '20px' }}>
          {orderForStatus && (
            <Box
              mb={2.5}
              p={1.5}
              style={{
                backgroundColor: '#f8fafc',
                borderRadius: 8,
                border: '1px solid #e2e8f0'
              }}
            >
              <Typography variant="body2" style={{ fontWeight: 600, color: '#334155', marginBottom: 4 }}>
                Mã đơn: <span style={{ color: '#1a73e8' }}>#{orderForStatus.code || orderForStatus.order_code || orderForStatus.id}</span>
              </Typography>
              <Typography variant="body2" style={{ color: '#64748b', marginBottom: 6 }}>
                Khách hàng: <strong>{orderForStatus.end_user?.full_name || orderForStatus.customer_name || orderForStatus.customerName || orderForStatus.agency?.name || '--'}</strong>
              </Typography>
              <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                <Typography variant="body2" style={{ color: '#64748b' }}>
                  Trạng thái hiện tại:
                </Typography>
                {(() => {
                  const currCfg = ORDER_STATUS_CONFIG[orderForStatus.status] || {
                    label: 'Không xác định',
                    color: '#666',
                    bg: '#f5f5f5'
                  };
                  return (
                    <Chip
                      label={currCfg.label}
                      size="small"
                      style={{
                        backgroundColor: currCfg.bg,
                        color: currCfg.color,
                        fontWeight: 700,
                        fontSize: 11,
                        border: `1px solid ${currCfg.color}44`,
                        height: 22
                      }}
                    />
                  );
                })()}
              </Box>
            </Box>
          )}

          <Box mt={1} mb={0.75}>
            <Typography variant="body2" style={{ fontWeight: 600, color: '#334155' }}>
              Trạng thái mới
            </Typography>
          </Box>
          <FormControl fullWidth variant="outlined" size="small">
            <Select
              id="order-status-select"
              value={newStatusValue}
              onChange={e => setNewStatusValue(e.target.value)}
              MenuProps={{
                getContentAnchorEl: null,
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left'
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left'
                },
                PaperProps: {
                  style: {
                    maxHeight: 250,
                    marginTop: 4,
                    borderRadius: 8,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.12)'
                  }
                }
              }}
            >
              {ORDER_STATUS_OPTIONS.map(opt => (
                <MenuItem key={opt.value} value={opt.value}>
                  <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                    <Box
                      style={{
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        backgroundColor: opt.color
                      }}
                    />
                    <Typography style={{ fontWeight: 600, color: opt.color, fontSize: 13 }}>
                      {opt.label}
                    </Typography>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions style={{ padding: '12px 20px', borderTop: '1px solid #e0e3ef' }}>
          <Button
            onClick={handleCloseStatusModal}
            variant="outlined"
            disabled={submittingStatus}
            style={{ fontWeight: 600, textTransform: 'none' }}
          >
            Hủy
          </Button>
          <Button
            onClick={handleSaveOrderStatus}
            variant="contained"
            disabled={submittingStatus || (orderForStatus && newStatusValue === orderForStatus.status)}
            style={{
              backgroundColor: '#e67e22',
              color: '#fff',
              fontWeight: 600,
              textTransform: 'none'
            }}
            startIcon={submittingStatus ? <CircularProgress size={16} color="inherit" /> : null}
          >
            {submittingStatus ? 'Đang lưu...' : 'Cập nhật'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmDialogs;
